/* eslint-disable jsx-a11y/no-static-element-interactions */

import * as React from 'react';
import s from '../Carousel.scss';
import {Arrow, ArrowDirection} from '../CarouselDesktop/Arrow/Arrow';
import {CarouselAriaLabels} from '../Carousel';

export interface CarouselMobileProps {
  slidesCount: number;
  activeSlide: number;
  slideTo: (index: number) => void;
  pagination?: React.ReactNode;
  showNavigationArrows?: boolean;
  ariaLabels?: CarouselAriaLabels;
  slideNext?: () => void;
  slidePrev?: () => void;
}

export enum MobileCarouselDataHooks {
  MobileCarousel = 'carousel-mobile',
  MobileCarouselContainer = 'carousel-mobile-container',
  PreviousArrow = 'mobile-left-arrow',
  NextArrow = 'mobile-right-arrow',
}

export const CarouselMobile: React.FC<CarouselMobileProps> = (props) => {
  const {pagination, showNavigationArrows, ariaLabels, slideNext, slidePrev} = props;

  return (
    <div className={s.carouselWrapper} data-hook={MobileCarouselDataHooks.MobileCarouselContainer}>
      {showNavigationArrows && ariaLabels && (
        <Arrow
          ariaLabel={ariaLabels.arrowLeft}
          dataHook={MobileCarouselDataHooks.PreviousArrow}
          onClick={slidePrev}
          onKeyPress={slidePrev}
          direction={ArrowDirection.LEFT}
          className={s.arrow}
        />
      )}
      <div
        className={s.carousel}
        data-hook={MobileCarouselDataHooks.MobileCarousel}
        tabIndex={showNavigationArrows ? undefined : 0}>
        {props.children}
      </div>
      {showNavigationArrows && ariaLabels && (
        <Arrow
          ariaLabel={ariaLabels.arrowRight}
          dataHook={MobileCarouselDataHooks.NextArrow}
          onClick={slideNext}
          onKeyPress={slideNext}
          direction={ArrowDirection.RIGHT}
          className={s.arrow}
        />
      )}
      {pagination && <div className={s.pagination}>{pagination}</div>}
    </div>
  );
};
